import * as ng from 'angular';
import {IUser} from '../../../commons/interfaces/user/user';
import {ArchiSmallServices} from '../../../services/archismall.service';
import {IStorageUsageStatistics} from '../../../commons/interfaces/storageUsageStatistics';
import {IStorageArchiviaUser} from '../../../commons/interfaces/IStorageUsageUser';
import {IStorageUsageClassDocStatistics} from '../../../commons/interfaces/storageUsageClassDocStatistics';
import {IInvoices} from '../../../commons/interfaces/user/invoices';


class ViewStoricoConservazioneController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$timeout',
    '$uibModalStack',
    '$state',
    'ArchiSmallServices',
    'store',
  ];

  constructor(
    private $scope: {
      user: IUser;
      invoices: IInvoices[],
      invoicesYearsSent: { [key: number]: number };
      invoicesYearsReceived: { [key: number]: number };
      [key: string]: any
    },
    private $rootScope: any,
    private $timeout: ng.ITimeoutService,
    private $modalStack: ng.ui.bootstrap.IModalStackService,
    private $state: any,
    private ArchiSmallServices: ArchiSmallServices,
    private store: ng.a0.storage.IStoreService,
  ) {
    // todo: finire impplementazione

    $scope.pageHeader = 'Visualizza Storico Utilizzo';
    $scope.user = store.get('user');

    ArchiSmallServices.getStorageArchive($scope.user.accountData.email, [])
      .then((response) => {
        $scope.spaceArchivia = JSON.parse(JSON.stringify(response)) as IStorageArchiviaUser[];
        if ($scope.spaceArchivia.length > 0) {
          const currentYearArchivia = $scope.spaceArchivia.filter(item => item.year === $scope.currentYear);
          if (currentYearArchivia.length > 0) {
            $scope.consumiArchiviaCurrentYear = Number(((currentYearArchivia[0].size) / Math.pow(1024, 2)).toFixed(2));
          }
          $scope.consumiArchiviaList = $scope.spaceArchivia.sort(({year: a}, {year: b}) => b - a);
          $scope.consumiArchivia = Number((($scope.consumiArchiviaList.reduce((prev, curr) => curr.size + prev, 0)) / (Math.pow(1024, 2))).toFixed());
        } else {
          $scope.consumiArchiviaList = [];
          $scope.consumiArchivia = 0;
        }
      });

    ArchiSmallServices
      .getStorageUsageClassDocEmailYears($scope.user.accountData.email, [])
      .then(response => {
        $scope.classDocPec = (JSON.parse(JSON.stringify(response)) as IStorageUsageClassDocStatistics[]).filter(item => item.docClass === 'pec_posta_elettronica_certificata' || item.docClass === 'pec_notifiche_pec');
        if ($scope.classDocPec.length > 0) {
          $scope.consumiPec = $scope.classDocPec.sort(({year: a}, {year: b}) => (b - a));
          $scope.consumoTotalePec = parseFloat(((($scope.consumiPec.reduce((prev, curr) => prev + curr.size, 0)) / Math.pow(1024, 2))).toFixed(2));
        } else {
          $scope.consumiPec = [];
          $scope.consumoTotalePec = 0;
        }

      }).catch(err => {
      console.error(err);
    });

    ArchiSmallServices
      .getStorageUsageCeYears($scope.user.accountData.email, [])
      .then(response => {
        $scope.consumiConservazioneBE = (JSON.parse(JSON.stringify(response)) as IStorageUsageStatistics[]);
        if ($scope.consumiConservazioneBE.length > 0) {
          const currentYearData = $scope.consumiConservazioneBE.filter((item: {
            year: any;
          }) => item.year === $scope.currentYear);
          if (currentYearData.length > 0) {
            let consumiConservazionecCurrentYearAppoggio = ((currentYearData[0].storageUsageInBytes) / Math.pow(1024, 2)).toFixed(2);
            if ($scope.consumiArchiviaCurrentYear !== undefined && $scope.consumiArchiviaCurrentYear !== null) {
              $scope.consumiConservazionecCurrentYear = (parseFloat(consumiConservazionecCurrentYearAppoggio) + $scope.consumiArchiviaCurrentYear).toPrecision(4);
            } else {
              $scope.consumiConservazionecCurrentYear = ((parseFloat(consumiConservazionecCurrentYearAppoggio)));
            }
          }
          $scope.consumiConservazioneList = $scope.consumiConservazioneBE.sort(({year: a}, {year: b}) => b - a);
          $scope.consumiConservazione = (($scope.consumiConservazioneList.reduce((prev, curr) => curr.storageUsageInBytes + prev, 0)) / (Math.pow(1024, 2))).toFixed(2);
        } else {
          $scope.consumiConservazioneList = [];
          $scope.consumiConservazione = 0;
        }

        if ($scope.yearsFatture === undefined || $scope.yearsFatture.length === 0) {
          $scope.yearsList = $scope.consumiConservazioneList
            .map((item => item.year))
            .sort((a, b) => b - a)
            .filter((v, i, a) => {
              // rimuove duplicati
              return a.indexOf(v) === i;
            });
        } else {
          $scope.yearsList = $scope.yearsFatture.concat(...$scope.consumiConservazioneList
            .map((item => item.year)))
            .sort((a, b) => b - a)
            .filter((v, i, a) => {
              // rimuove duplicati
              return a.indexOf(v) === i;
            });
        }

      }).catch(err => {
      console.error(err);
    });

    ArchiSmallServices.getInvoices($scope.user.accountData.email, []).then(response => {
      $scope.invoices = JSON.parse(JSON.stringify(response));
      $scope.invoicesYearsSent = {};
      $scope.invoicesYearsReceived = {};
      $scope.invoices.forEach(invoice => {
        $scope.invoicesYearsSent[invoice.year] = ($scope.invoicesYearsSent[invoice.year] || 0) + invoice.invoicesSent;
        $scope.invoicesYearsReceived[invoice.year] = ($scope.invoicesYearsReceived[invoice.year] || 0) + invoice.invoicesReceived;
      });
    });

    $scope.getConsumoConservazioneAnno = (year: any) => {
      let sum = 0;
      for (let i = 0; i < $scope.consumiConservazioneList.length; i++) {
        if ($scope.consumiConservazioneList[i].year === year) {
          sum += parseFloat(($scope.consumiConservazioneList[i].storageUsageInBytes / Math.pow(1024, 2)).toFixed(2));
        }
      }
      return sum;
    };
    $scope.getConsumoSpazioPecAnno = (year: number) => {
      let sum = 0;

      for (let i = 0; i < $scope.consumiPec.length; i++) {
        if ($scope.consumiPec[i].year === year) {
          sum += parseFloat(($scope.consumiPec[i].size / Math.pow(1024, 2)).toFixed(2));
        }
      }
      return sum;
    };

    $scope.getConsumoArchiviaAnno = (year: number) => {
      let sum = 0;

      for (let i = 0; i < $scope.consumiArchiviaList.length; i++) {
        if ($scope.consumiArchiviaList[i].year === year) {
          sum += parseFloat(($scope.consumiArchiviaList[i].size / Math.pow(1024, 2)).toFixed(2));
        }
      }
      return sum;
    };
  }
}


export const ViewStoricoConservazioneComponent: ng.IComponentOptions = {

  template: require('./view-storico-utilizzo.html'),
  controller: ViewStoricoConservazioneController,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/view-storico-utilizzo/view-storico-utilizzo.ts